import {useEffect,useRef,useState} from 'react';
import api, {getErrorMessage} from '@/lib/api';

export default function IndexScopeDecision({engagementId, item, onSaved}) {
  const decision = item.scope_decision || {};
  const [choice, setChoice] = useState('');
  const [basis, setBasis] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [history, setHistory] = useState(null);
  const generation=useRef(0),historyRequest=useRef(0);
  const identity=JSON.stringify([engagementId,item.template_id,decision.version||0]);
  const currentIdentity=useRef(identity);currentIdentity.current=identity;
  useEffect(()=>{generation.current++;historyRequest.current++;setChoice('');setBasis('');setBusy(false);setError('');setHistory(null);return()=>{generation.current++;historyRequest.current++;};},[identity]);
  const path = `/engagements/${engagementId}/audit-index/decisions/${item.template_id}`;
  const act = async action => {
    const owner=generation.current,isCurrent=()=>owner===generation.current&&currentIdentity.current===identity;
    setBusy(true); setError('');
    const body = {action, expected_version: decision.version || 0};
    if (action === 'prepare') Object.assign(body, {decision: choice, rationale: basis});
    if (action === 'review') body.review_note = basis;
    if (action === 'reopen') body.reason = basis;
    try {
      const response=await api.post(path, body);if(!isCurrent())return;
      onSaved(response.data);
      setChoice(''); setBasis(''); setHistory(null);
    } catch (e) {if(isCurrent())setError(getErrorMessage(e));}
    finally {if(isCurrent())setBusy(false);}
  };
  const loadHistory=async()=>{const owner=generation.current,request=++historyRequest.current,isCurrent=()=>owner===generation.current&&currentIdentity.current===identity&&request===historyRequest.current;setError('');setHistory(null);try{const response=await api.get(path+'/history');if(isCurrent())setHistory(response.data);}catch(e){if(isCurrent())setError(getErrorMessage(e));}};
  return <section aria-label={`Keputusan lingkup ${item.code}`} className="border p-2 space-y-2">
    <h4 className="font-semibold">Keputusan penerapan lingkup</h4>
    <p>v{decision.version || 0} · {decision.effective_status || decision.status || 'NOT_STARTED'}</p>
    {decision.rationale && <p>{decision.decision} · {decision.rationale}</p>}
    {decision.prepared_by_user_id && <p>Disiapkan: {decision.prepared_by_name} · {decision.prepared_at}</p>}
    {decision.reviewed_by_user_id && <p>Direviu: {decision.reviewed_by_name} · {decision.reviewed_at} · {decision.review_note}</p>}
    {error && <p role="alert">{error}</p>}
    <fieldset disabled={busy}>
      {decision.can_prepare && <label className="block">Penerapan aktual
        <select aria-label={`Penerapan ${item.code}`} value={choice} onChange={e=>setChoice(e.target.value)}>
          <option value="">Pilih keputusan aktual</option>
          <option value="REQUIRED">Wajib</option>
          <option value="NOT_APPLICABLE">Tidak berlaku</option>
        </select>
      </label>}
      {(decision.can_prepare || decision.can_review || decision.can_reopen) && <label className="block">Dasar keputusan / reviu / pembukaan kembali
        <textarea className="border block w-full" aria-label={`Dasar keputusan ${item.code}`} value={basis} onChange={e=>setBasis(e.target.value)}/>
      </label>}
      {decision.can_prepare && <button className="mr-2 rounded border px-3 py-1 disabled:opacity-50" type="button" disabled={!choice || !basis.trim()} onClick={()=>act('prepare')}>Siapkan keputusan {item.code}</button>}
      {decision.can_review && <button className="mr-2 rounded border px-3 py-1 disabled:opacity-50" type="button" disabled={!basis.trim()} onClick={()=>act('review')}>Reviu keputusan {item.code}</button>}
      {decision.can_reopen && <button className="mr-2 rounded border px-3 py-1 disabled:opacity-50" type="button" disabled={!basis.trim()} onClick={()=>act('reopen')}>Buka kembali keputusan {item.code}</button>}
      <button className="mr-2 rounded border px-3 py-1 disabled:opacity-50" type="button" onClick={loadHistory}>Riwayat keputusan {item.code}</button>
    </fieldset>
    {history && <ol>{history.map(row=><li key={row.id}>v{row.version} · {row.status} · {row.decision} · {row.rationale} · {row.review_note || row.reopen_reason} · {row.recorded_at}</li>)}</ol>}
  </section>;
}
